import React, { useEffect, useRef } from "react";
import AgoraRTC from "agora-rtc-sdk-ng";

const AgoraVideoCall = ({
	appId = "9c8963803ecd4d59a5cb122fe886d742",
	token,
	channelName,
	preStream,
}) => {
	const localRef = useRef(null);
	const remoteRef = useRef(null);
	const clientRef = useRef(null);

	useEffect(() => {
		if (!token || !channelName) return;

		const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
		clientRef.current = client;

		let micTrack, camTrack;

		const joinCall = async () => {
			try {
				console.log(appId, channelName, "asdjad3");
				await client.join(appId, channelName, token?.replace(/\//g, ""), 1); // ✅ dynamic

				if (preStream) {
					// Convert MediaStream tracks to Agora LocalTracks
					const audioTrackRaw = preStream.getAudioTracks()[0];
					const videoTrackRaw = preStream.getVideoTracks()[0];

					if (audioTrackRaw)
						micTrack = AgoraRTC.createCustomAudioTrack({
							mediaStreamTrack: audioTrackRaw,
						});

					if (videoTrackRaw)
						camTrack = AgoraRTC.createCustomVideoTrack({
							mediaStreamTrack: videoTrackRaw,
						});

					if (localRef.current && videoTrackRaw) {
						localRef.current.srcObject = new MediaStream([videoTrackRaw]);
						localRef.current.play();
					}
				} else {
					[micTrack, camTrack] =
						await AgoraRTC.createMicrophoneAndCameraTracks();
					if (localRef.current) camTrack.play(localRef.current);
				}

				if (micTrack) await client.publish(micTrack);
				if (camTrack) await client.publish(camTrack);

				client.on("user-published", async (user, mediaType) => {
					await client.subscribe(user, mediaType);

					if (mediaType === "video" && user.videoTrack && remoteRef.current) {
						user.videoTrack.play(remoteRef.current);
					}

					if (mediaType === "audio" && user.audioTrack) {
						user.audioTrack.play();
					}
				});
			} catch (err) {
				console.error("Error joining call:", err);
			}
		};

		joinCall();

		return () => {
			client.leave().then(() => {
				client.removeAllListeners();
				micTrack && micTrack.stop && micTrack.close();
				camTrack && camTrack.stop && camTrack.close();
			});
		};
	}, [appId, token, channelName, preStream]);

	return (
		<div style={{ display: "flex", gap: "20px" }}>
			<div>
				<h4>Local</h4>
				<video
					ref={localRef}
					autoPlay
					muted
					playsInline
					width={300}
					height={200}
				/>
			</div>
			<div>
				<h4>Remote</h4>
				<div
					ref={remoteRef}
					style={{ width: 300, height: 200, backgroundColor: "#000" }}
				/>
			</div>
		</div>
	);
};

export default AgoraVideoCall;
